import React, { useContext, useState, useEffect, useRef } from "react";
import { baseUrl, dataContext } from "../../App";
import "./Profile.css";
import avatarImg from "../../assets/img/leaderboard/avatar.png";
import scoreBgImg from "../../assets/img/v2/score_bg.png";
import ProfileEditModal from "../ProfileEditModal/ProfileEditModal";
import activityLogSubmission from "../../helper/activitylog";
import analyticEvent from "../../helper/gaEvent";
import { FaShare } from "react-icons/fa6";
import { pushCleverTapEvent } from "../../helper/clevertapFunction";
import ProfileUpper from "./ProfileUpper/ProfileUpper";
import EventScore from "./EventScore/EventScore";
import ReferralHistory from "./ReferralHistory/ReferralHistory";
import PlayingHistory from "../BannerPart3/PlayingHistory/PlayingHistory";
import ProfileSubscriptionStatus from "./ProfileSubscriptionStatus/ProfileSubscriptionStatus";
import { fetchUserLeaderboard } from "../../services";

const Profile = ({ setShowRefundModal,showLoginModal, setShowLoginModal, setShowReferModal, setActiveBottom, quizClickHandler,setShowOtpModal }) => {
  const { token, setToken, playerData, setPlayerData, events, setEvents } =
    useContext(dataContext);
  const [showProfileEditModal, setShowProfileEditModal] = useState(false);
  const [showReferralHistory, setShowReferralHistory] = useState(false);
  const [playerLeaderboardData, setPlayerLeaderboardData] = useState([]);
  const [memoryMatchLeaderboardData, setMemoryMatchLeaderboardData] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const timeoutRef = useRef(null); // To keep track of the timeout

  const handleClick = () => {
    // Clear any previous timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Show the tooltip
    setShowTooltip(true);

    // Set a new timeout to hide the tooltip after 1000ms
    timeoutRef.current = setTimeout(() => {
      setShowTooltip(false);
    }, 400);
  };

  // Clear the timeout if the component unmounts to avoid memory leaks
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  const tooltipStyle = {
    visibility: "visible",
    backgroundColor: "black",
    color: "#fff",
    textAlign: "center",
    borderRadius: "5px",
    padding: "5px 10px",
    position: "absolute",
    zIndex: 1,
    bottom: "125%", // Position above the button
    left: "50%",
    transform: "translateX(-50%)",
    opacity: 1,
    transition: "opacity 0.3s"
  };
  useEffect(() => {
    if (playerData?.id) {
    } else {
      setShowLoginModal(true);
    }
    let msisdn = null;

    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("profile", msisdn);
    analyticEvent('profile', 'profile-view')
    pushCleverTapEvent('CheckIn-Profile');
  }, []);
  
  useEffect(() => {
    if (token) {
      fetchUserLeaderboard(token).then((res) => {
        setPlayerLeaderboardData(res?.leaderboard || []);
        setMemoryMatchLeaderboardData(res?.memorymatch_leaderboard || []);
      });
    }
  }, [playerData]);

  return (
    <>
      <div className="profileWrapper">
        <ProfileUpper playerData={playerData} setShowProfileEditModal={setShowProfileEditModal} />
        <EventScore events={events} playerLeaderboardData={playerLeaderboardData} memoryMatchLeaderboardData={memoryMatchLeaderboardData} />
        <div className="subsCription" style={{ padding: '24px 16px' }}>
          <ProfileSubscriptionStatus
            isSubscribe={playerData?.isSubscribe}
            isSubscribeSpellingBee={playerData?.isSubscribeSpellingBee}
            isSubscribeMemoryMatch={playerData?.isSubscribeMemoryMatch}
            setShowOtpModal={setShowOtpModal}
            setShowRefundModal={setShowRefundModal}
          />
        </div>
        <ReferralHistory />
        <PlayingHistory events={events} playerData={playerData} quizClickHandler={quizClickHandler} />
      </div>
      
      {showProfileEditModal && (
        <ProfileEditModal
          showProfileEditModal={showProfileEditModal}
          setShowProfileEditModal={setShowProfileEditModal}
        ></ProfileEditModal>
      )}
      {showReferralHistory && (
        <ReferralHistory
          showReferralHistory={showReferralHistory}
          setShowReferralHistory={setShowReferralHistory}
          setShowLoginModal={setShowLoginModal}
        ></ReferralHistory>
      )}
    </>
  );
};

export default Profile;
